import React, { Component } from "react";
import "./index.css";

class PersonCards extends Component {
  shouldComponentUpdate() {
    return false;
  }

  render() {
    const { persons } = this.props;
    return (
      <div className="columns is-multiline">
        <div className="column is-12">
          Дружеството се управлява от Съвет на директорите в състав:
        </div>
        <div className="column is-12">
          {persons.map(({ name, avatar }, index) => (
            <p key={index}>
              <b>{name}</b>
            </p>
          ))}
        </div>
      </div>
    );
  }
}

export default PersonCards;



// WEBPACK FOOTER //
// ./src/presentational/PersonCards/index.js